import { apiSlice } from "../apiSlice";

export interface CartApiResponse {
  carts: any;
}

export interface Category {
  display: string;
  image: string;
  score: number;
}
const API_BASE_DOMAIN = process.env.REACT_APP_API_BASE_DOMAIN_PRODUCTION;
export const cartService = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCartListByRestaurantId: builder.query<CartApiResponse, string>({
      query: (restaurantId) => ({
        url: `https://customersitehttps-getcartlistbyrestaurantid-${API_BASE_DOMAIN}-uc.a.run.app?restaurantId=${restaurantId}`,
        method: "GET",
      }),
    }),
  }),
});

export const { useGetCartListByRestaurantIdQuery } = cartService;
